"use strict";
angular.module("roleManagementServiceModule", [
    "createRoleModule", //新建角色
]).
factory("roleManagementService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [createProduct description] 新增/编辑角色
         * @param {[string]} [userId] [description] 
         */
        createRole: function(roleId,roleName) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/roleManagement/service/createRole/createRole_tpl.html",
                windowClass: 'createRole backstageModalHeader',
                backdrop: false,
                controller: "createRoleCtrl",
                resolve: {
                    roleId: function(){
                    	return roleId;
                    },
                    roleName:function(){
                    	return roleName;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);